export { default } from './CTAInline';
